import React from "react";
import { CtaButton } from "../CtaButton";
export function ReframeSection() {
  return <section className="bg-ink px-4 py-14 text-white sm:py-20" data-id="element-256" data-mp="3q5ilssm72lwc">
      <div className="mx-auto max-w-2xl" data-id="element-257" data-mp="3q3xrn43sl4z0">
        <h2 className="text-balance text-center font-serif text-3xl font-bold leading-tight sm:text-4xl" data-id="element-258" data-mp="3l6604b727kvc">
          And it doesn't have to be <em className="text-rose-soft" data-id="element-259" data-mp="3g9fmrvmn33dm">this disorganized.</em>
        </h2>
        <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-white/85" data-id="element-260" data-mp="hp5xvqzua4fi">
          <p data-id="element-261" data-mp="cqmd3twzeyoq">The problem isn't necessarily a lack of knowledge.</p>
          <p data-id="element-262" data-mp="cpb8xszmjox3">
            Often, the challenge is turning extensive clinical information into a practical structure that can be
            consulted when you need it. That's exactly what I wanted to solve when I developed Menopause Decision Map™.
          </p>
          <p data-id="element-263" data-mp="2sj1q1rt40gcp">
            I created a collection of visual maps, checklists, and consultation resources to help you organize the
            assessment process without having to build everything from scratch.
          </p>
          <p className="rounded-2xl bg-white/10 p-5 font-serif text-xl font-semibold leading-snug text-white" data-id="element-264" data-mp="1afdf48hh43r9">
            You don't need another textbook to leave on your shelf. You need practical resources designed around the
            questions that arise in clinical practice.
          </p>
        </div>
        <CtaButton className="mt-10" label="Yes, I want the decision map system" data-id="element-265" data-mp="15k7tzbvwat48" />
      </div>
    </section>;
}